import { InlineMath, BlockMath } from "react-katex";
import React from "react";
import SelectInput from "../../../../components/inputs/SelectInput"; // na górze pliku


// Losowanie z wagami
function weightedRandom(options) {
  const totalWeight = options.reduce((acc, [_, weight]) => acc + weight, 0);
  const rnd = Math.random() * totalWeight;
  let sum = 0;
  for (const [value, weight] of options) {
    sum += weight;
    if (rnd <= sum) return value;
  }
}

// Główne generowanie
export function generateTask() {
  const expected = weightedRandom([
    ["stały", 15],
    ["niemonotoniczny", 25],
    ["rosnący", 30],
    ["malejący", 30],
  ]);

  let sequence = [];

  if (expected === "stały") {
    const value = getRandomInt(-20, 20);
    sequence = Array(5).fill(value);
  }

  else if (expected === "niemonotoniczny") {
    while (true) {
      const values = Array.from({ length: 5 }, () => getRandomInt(-20, 20));
      const diffs = values.map((v, i) => i > 0 ? v - values[i - 1] : 0).slice(1);
      const hasRise = diffs.some(d => d > 0);
      const hasFall = diffs.some(d => d < 0);
      if (hasRise && hasFall) {
        sequence = values;
        break;
      }
    }
  }

  else if (expected === "rosnący" || expected === "malejący") {
    const useArithmetic = Math.random() < 1 / 3;
    const start = getRandomInt(-20, 10);
    const diff = getRandomInt(1, 5) * (expected === "rosnący" ? 1 : -1);

    if (useArithmetic) {
      sequence = Array.from({ length: 5 }, (_, i) => start + i * diff);
    } else {
      let current = start;
      sequence = [];
      for (let i = 0; i < 5; i++) {
        const step = getRandomInt(1, 5);
        current += step * (expected === "rosnący" ? 1 : -1);
        sequence.push(current);
      }
    }
  }

  return {
    type: "CheckMonotonicityGivenSequenceTask",
    data: { sequence },
    answer: expected,
  };
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Renderowanie polecenia
export function renderTask({ data }) {
  const { sequence } = data;

  const items = sequence.map((val, idx) => `a_${idx + 1} = ${val}`);
  const display = items.join(",\\quad ");

  return (
    <div className="space-y-2">
      <p>Określ monotoniczność ciągu:</p>
      <BlockMath math={display} />
    </div>
  );
}

// Input: wybór jednej z opcji
export function renderInput({ data }, userAnswer, onChange, disabled) {
  const options = [
    { value: "rosnący", label: "rosnący" },
    { value: "malejący", label: "malejący" },
    { value: "stały", label: "stały" },
    { value: "niemonotoniczny", label: "niemonotoniczny" },
  ];

  return (
    <SelectInput
      value={userAnswer || ""}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      options={options}
    />
  );
}

// Poprawna odpowiedź
export function renderAnswer({ answer }) {
  return <i>{answer}</i>;
}

// Sprawdzenie odpowiedzi
export function checkAnswer({ answer }, userAnswer) {
  return answer === userAnswer;
}

// Wyjaśnienie
export function renderExplanation({ data, answer }) {
  const { sequence } = data;
  return (
    <div style={{ textAlign: "left" }}>
      <p><strong>Wyrazy ciągu:</strong></p>
      <BlockMath math={sequence.map((v, i) => `a_${i + 1} = ${v}`).join(",\\quad ")} />

      <p className="mt-2">
        <strong>Odpowiedź:</strong> {answer}
      </p>
      <p>
        Aby ustalić monotoniczność, sprawdzamy czy ciąg jest stale rosnący,
        malejący, stały lub czy zawiera zmiany kierunku.
      </p>
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "string" || userAnswer.trim() === "") {
    return <i>(brak odpowiedzi)</i>;
  }
  return <span>{userAnswer}</span>;
}
